<template>
  <section v-if="items.length" class="obra-recommendations" :aria-labelledby="titleId">
    <div class="obra-recommendations__header">
      <h2 :id="titleId" class="obra-recommendations__title">{{ title }}</h2>
    </div>

    <div class="obra-recommendations__viewport" :class="{ 'obra-recommendations__viewport--start': !canScrollPrev, 'obra-recommendations__viewport--end': !canScrollNext }">
      <v-btn
        v-if="canScrollPrev"
        icon
        class="obra-recommendations__arrow obra-recommendations__arrow--prev"
        aria-label="Voltar obras recomendadas"
        @click="scrollByPage(-1)"
      >
        <v-icon color="white">mdi-chevron-left</v-icon>
      </v-btn>
      <div
        ref="rail"
        class="obra-recommendations__rail"
        role="list"
        tabindex="0"
        aria-label="Obras recomendadas"
        @scroll.passive="updateScrollState"
        @keydown.left.prevent="scrollByPage(-1)"
        @keydown.right.prevent="scrollByPage(1)"
      >
        <router-link
          v-for="item in items"
          :key="item.id"
          class="obra-recommendations__item"
          :to="projectPath(item)"
          role="listitem"
        >
          <span class="obra-recommendations__cover-frame">
            <img
              v-if="item.project_thumb"
              class="obra-recommendations__cover"
              :src="item.project_thumb"
              :alt="`Capa da obra ${item.name || ''}`"
              loading="lazy"
              @contextmenu.prevent
            />
            <span v-else class="obra-recommendations__cover obra-recommendations__cover--empty">
              <v-icon color="#eadcff">mdi-book-open-page-variant</v-icon>
            </span>
            <span
              class="obra-recommendations__age-rating"
              :style="ageRatingStyle(item)"
            >
              {{ ageRatingLabel(item) }}
            </span>
          </span>
          <span class="obra-recommendations__name">{{ item.name }}</span>
          <span class="obra-recommendations__meta">
            {{ item.language && item.language.name ? item.language.name : 'pt-br' }}
            <span v-if="item.gender && item.gender.name">{{ item.gender.name }}</span>
          </span>
        </router-link>
      </div>
      <v-btn
        v-if="canScrollNext"
        icon
        class="obra-recommendations__arrow obra-recommendations__arrow--next"
        aria-label="Avancar obras recomendadas"
        @click="scrollByPage(1)"
      >
        <v-icon color="white">mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </section>
</template>

<script>
import { projectPath } from '@/utils/projectRoutes';

export default {
  name: 'ObraRecommendations',
  props: {
    title: { type: String, required: true },
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      canScrollPrev: false,
      canScrollNext: false,
    };
  },
  computed: {
    titleId() {
      return `obra-recommendations-${this.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    },
  },
  mounted() {
    this.$nextTick(this.updateScrollState);
    window.addEventListener('resize', this.updateScrollState);
  },
  updated() {
    this.$nextTick(this.updateScrollState);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollState);
  },
  methods: {
    projectPath,
    scrollByPage(direction) {
      const rail = this.$refs.rail;
      if (!rail) return;

      rail.scrollBy({
        left: direction * Math.max(rail.clientWidth - 56, 180),
        behavior: 'smooth',
      });
    },
    updateScrollState() {
      const rail = this.$refs.rail;
      if (!rail) return;

      const maxScroll = rail.scrollWidth - rail.clientWidth;
      this.canScrollPrev = rail.scrollLeft > 2;
      this.canScrollNext = maxScroll > 2 && rail.scrollLeft < maxScroll - 2;
    },
    ageRatingLabel(item) {
      return item?.age_rating?.rating || 'Livre';
    },
    ageRatingStyle(item) {
      const age = Number(item?.age_rating?.age || 10);
      return {
        backgroundColor: this.ratingColor(age),
        color: age === 12 ? '#000' : '#fff',
      };
    },
    ratingColor(age) {
      if (age <= 10) return '#0095DA';
      if (age <= 12) return '#FBC115';
      if (age <= 14) return '#F58220';
      return '#EC1D25';
    },
  },
};
</script>
